import { render } from "./ProjectEdit.vue?vue&type=template&id=fd98c45a"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__